import { render, staticRenderFns } from "./ParticleGLSL.vue?vue&type=template&id=30db9c5d&"
import script from "./ParticleGLSL.vue?vue&type=script&lang=js&"
export * from "./ParticleGLSL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports